var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"back-to-top",on:{"click":_vm.scrollToTop}},[_vm._v(" "+_vm._s(_vm.$t('backToTop'))+" "),_c('i',{staticClass:"fas fa-chevron-up"})])}
var staticRenderFns = []

export { render, staticRenderFns }